module.exports = __webpack_public_path__ + "76e6bc156ec0eed14120c1ad750fbafc.svg";